const validationMsgs = {
  required: 'This field is required.',
  emailInvalid: 'E-mail is not valid.',
};

export default validationMsgs;
